<template>
	<div class="welcome-container">
		<div class="space"></div>
		
		<h1>Welcome to AppWAFN</h1>
		<p>We're glad you're here. AppWAFN is your structured registry for everything that matters.</p>
		<p>Log in or sign up to start organizing your world.</p>
		<!-- Add more content as needed -->
	</div>
</template>

<script>
	export default {
		name: 'WelcomeView'
	}
</script>

<style scoped>
	.welcome-container {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		padding: 40px;
		text-align: center;
		color: #2c3e50;
	}
	.space {
		height: 20px;
	}
	h1 {
		font-size: 2.5rem;
		margin-bottom: 20px;
	}
	p {
		font-size: 1.2rem;
		max-width: 600px;
	}
</style>